import Constants from '@data/Constants';
import moment from 'moment';
import { minutesToSumHour, hourToMinutes, addTimes } from '@common/Func';

let status = {
   'TODO': 'A fazer',
   'DOING': 'Fazendo',
   'STOPPED': 'Impeditivo',
   'DONE': 'Finalizado'
}

function photo(e, users) {
   let _users = (e.usersphoto || []).map(e => {

      let photo = e.photo && `${Constants.APIRoot}/public/users/${e.id_user}/profileLogo.png`;

      return {
         id: e.id_user,
         src: photo || undefined,
         name: e.name_user || ''
      }
   });

   return _users;
}

function subtractHours(h1, h2) {
   h1 = hourToMinutes(h1);
   h2 = hourToMinutes(h2);

   return minutesToSumHour(h2 <= h1 ? 0 : h2 - h1);
}

export function activitiesList({ a, users, pj }) {
   let time_realized = (pj.hours_consumed || [])
      .filter(e => e.fk_id_activity == a.id_project_activity)
      .map(e => e.hours_consumed)
      .reduce((n, e) => addTimes(n, e), '00:00');

   return {
      id: a.id_project_activity,
      activity: a.name,
      sponsors: photo(a, users).filter(Boolean),
      evolution: parseInt(a.percent),
      status: status[a.stage || 'TODO'],
      dt_i: moment(a.dt_i).format('L'),
      dt_f: moment(a.dt_f).format('L'),
      time_prev: (a.hours || 0).toString().padStart(2, 0) + ':' + (a.minutes || 0).toString().padStart(2, 0),
      time_realized
   }
}
export function jsonFormatKanban(e, users) {

   return {
      id: e.id_project_activity, //importante colocar o id da atividade aqui, é a key do loop e o id do drag-drop
      avatares: photo(e, users),
      tags: (e.tagac || []).map(e => ({
         name: e.name,
         color: e.color,
         id_project_tag: e.id_project_tag
      })),
      name: e.name,
      dt: moment(e.dt_end).format('L'),
      dt_end: e.dt_end,
      commentsTotal: (e.comments || []).length,
      filesTotal: (e.file || []).length,
      percent: parseInt(e.percent),
      percentColor: '#f05e02',
      id_project_activity: e.id_project_activity,
      dt_start: e.dt_start,
      activity: e
   }
}
export function projectListFormat({ options, companyOptions, users, e, actDetail }) {

   let fileFormat = (f) => ({
      label: f.name,
      size: f.size,
      id_project_file: f.id_project_file,
      id_project: f.id_project
   });

   let _photo = photo(e, users);
   return {
      id: e.id_project,
      closed: e.closed,
      company: options.getOptions(companyOptions, e.fk_id_company),
      name: e.name,
      type: e.type_project,
      ListAvatars: [_photo.find(p => p.id == e.user_cad)].concat(_photo.filter(p => p.id != e.user_cad)).filter(Boolean),
      user_cad: e.user_cad,
      Scope: e.scope,
      goal: e.goal,
      risk: e.risk_project,
      EvolutionKPI: [
         {
            title: 'Backlog',
            key: 'BACKLOG',
            value: e.utils.BACKLOG.length,
            data: (e.utils.BACKLOG || []).map(a => activitiesList({ a, users, pj: e }))
         },
         {
            title: 'A fazer',
            key: 'TODO',
            value: e.utils.TODO.length,
            data: (e.utils.TODO || []).map(a => activitiesList({ a, users, pj: e }))
         },
         {
            title: 'Fazendo',
            key: 'DOING',
            value: e.utils.DOING.length,
            data: (e.utils.DOING || []).map(a => activitiesList({ a, users, pj: e }))
         },
         {
            title: 'Impeditivo',
            key: 'STOPPED',
            value: e.utils.STOPPED.length,
            data: (e.utils.STOPPED || []).map(a => activitiesList({ a, users, pj: e }))
         },
         {
            title: 'Validação',
            key: 'VALIDATION',
            value: e.utils.VALIDATION.length,
            data: (e.utils.VALIDATION || []).map(a => activitiesList({ a, users, pj: e }))
         },
         {
            title: 'Finalizado',
            key: 'DONE',
            value: e.utils.DONE.length,
            data: (e.utils.DONE || []).map(a => activitiesList({ a, users, pj: e }))
         },
      ],
      ForeseenVsRealized: {
         foreseen: parseFloat(e.cust_project.toString().replace(',', '.')),
         realized: e.valoractivity
      },
      EvolutionProject: {
         percent: parseInt(e.percent) || 0,
         dt_i: moment(e.start_date).format('L'),
         dt_f: moment(e.end_date).format('L'),
         planned_hours: e.horas_planejadas,
         realized_hour: e.hour_consumida,
         balance: subtractHours(e.hour_consumida || '00:00:00', e.horas_planejadas || '00:00:00'),
         exceeded_hours: e.hour_excedida,
         color: e.utils.isDelay ? 'var(--danger)' : 'var(--success)'
      },
      FileList: [
         {
            label: 'Termo de abertura',
            files: (e.files || []).filter(e => e.key == 'ta').map(fileFormat)
         },
         {
            label: 'Termo de mudança',
            files: (e.files || []).filter(e => e.key == 'tm').map(fileFormat)
         },
         {
            label: 'Termo de encerramento',
            files: (e.files || []).filter(e => e.key == 'te').map(fileFormat)
         },
         {
            label: 'Anexo',
            files: (e.files || []).filter(e => e.key == 'at').map(fileFormat)
         },
         {
            label: 'Pauta',
            files: (e.files || []).filter(e => e.key == 'pa').map(fileFormat)
         },
      ],
      actDetail
   }
}
